import { UiBox, UiButtonBase, UiTypography } from "@smp/ui";
import clsx from "clsx";

import classes from "./header_button.module.css";
import { IProps } from "./header_button.types";

export const HeaderButton = ({
  captionLeft,
  className,
  isExpired,
  onClick,
  textLeft,
  textRight,
  ...props
}: IProps) => (
  <UiButtonBase
    className={clsx(classes.button, className, isExpired && classes.button_expired)}
    onClick={onClick}
    {...props}
  >
    <UiBox display="flex" flexDirection="column" pr={textRight ? 1 : 0}>
      <UiTypography variant={captionLeft ? "body1" : "h5"}>
        {textLeft}
      </UiTypography>

      {captionLeft && (
        <UiTypography variant="caption" sx={{ opacity: 0.7, fontWeight: 400 }}>
          {captionLeft}
        </UiTypography>
      )}
    </UiBox>

    {textRight && (
      <UiBox borderLeft="solid 1px #FFF" pl={1}>
        {textRight}
      </UiBox>
    )}
  </UiButtonBase>
);
